import * as yup from 'yup';
var Validation = /** @class */ (function () {
    function Validation() {
        Object.defineProperty(this, "schema", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: yup.object({
                estimatedMonthlyVolume: yup.number().required("Field is required"),
                pricingModel: yup.string().required("Field is required"),
                averageTicketAmount: yup.number().required("Field is required"),
                highestTicketAmount: yup.number().required("Field is required"),
                lowestTicketAmount: yup.number().required("Field is required"),
                averageNumberOfTransactions: yup.number().required("Field is required"),
                averageRefundRatio: yup.number().required("Field is required"),
                averageChargebackRatio: yup.number().required("Field is required"),
                majorRegionsYourTraficIsComingFrom: yup.object({
                    eu: yup.number().required("Field is required").default(0),
                    usa: yup.number().required("Field is required").default(0),
                    asia: yup.number().required("Field is required").default(0),
                    row: yup.number().required("Field is required")
                }),
                targetMarkets: yup.string().required("Field is required").nullable(),
                haveYouAcceptedCreditCardPayment: yup.boolean().required("Field is required"),
                processorPayment: yup.string().when('haveYouAcceptedCreditCardPayment', function (haveYouAcceptedCreditCardPayment) {
                    if (haveYouAcceptedCreditCardPayment) {
                        return yup.string().required("Field is required");
                    }
                    return yup.string().optional();
                }),
                processorAccountId: yup.string().when('haveYouAcceptedCreditCardPayment', function (haveYouAcceptedCreditCardPayment) {
                    if (haveYouAcceptedCreditCardPayment) {
                        return yup.string().required("Field is required");
                    }
                    return yup.string().optional();
                }),
                processorTimePeriod: yup.number().when('haveYouAcceptedCreditCardPayment', function (haveYouAcceptedCreditCardPayment) {
                    if (haveYouAcceptedCreditCardPayment) {
                        return yup.number().required("Field is required");
                    }
                    return yup.number().optional();
                }),
                isRelationshipTerminated: yup.boolean().required("Field is required"),
                reasonOfTermination: yup.string().when('isRelationshipTerminated', function (isRelationshipTerminated) {
                    if (isRelationshipTerminated) {
                        return yup.string().required("Field is required");
                    }
                    return yup.string().optional();
                }),
                isBlacklisted: yup.boolean().required("Field is required"),
                requiredProcessingCurriencies: yup.string().required("Field is required"),
                requiredSettlementsCurriencies: yup.string().required("Field is required"),
                requiredMoto: yup.boolean().required("Field is required"),
                percentViaMoto: yup.number().when('isRelationshipTerminated', function (requiredMoto) {
                    if (requiredMoto) {
                        return yup.number().required("Field is required");
                    }
                    return yup.number().optional();
                }),
                percentViaCreditCard: yup.number().when('isRelationshipTerminated', function (requiredMoto) {
                    if (requiredMoto) {
                        return yup.number().required("Field is required");
                    }
                    return yup.number().optional();
                }),
                require3Dprocessing: yup.boolean().required("Field is required"),
                requiredCardBrands: yup.array().min(1, 'Field is required').required('Field is required'),
                requestedAPMs: yup.string().required("Field is required"),
                paymentStatementDescriptorLine1: yup.string().required("Field is required"),
                paymentStatementDescriptorLine2: yup.string().required("Field is required")
            })
        });
        Object.defineProperty(this, "initialTouch", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: {
                estimatedMonthlyVolume: true,
                pricingModel: true,
                averageTicketAmount: true,
                highestTicketAmount: true,
                lowestTicketAmount: true,
                averageNumberOfTransactions: true,
                averageRefundRatio: true,
                averageChargebackRatio: true,
                majorRegionsYourTraficIsComingFrom: {
                    eu: true,
                    usa: true,
                    asia: true,
                    row: true
                },
                targetMarkets: true,
                haveYouAcceptedCreditCardPayment: true,
                processorPayment: true,
                processorAccountId: true,
                processorTimePeriod: true,
                isRelationshipTerminated: true,
                reasonOfTermination: true,
                isBlacklisted: true,
                requiredProcessingCurriencies: true,
                requiredSettlementsCurriencies: true,
                requiredMoto: true,
                percentViaMoto: true,
                percentViaCreditCard: true,
                require3Dprocessing: true,
                requiredCardBrands: true,
                requestedAPMs: true,
                paymentStatementDescriptorLine1: true,
                paymentStatementDescriptorLine2: true
            }
        });
    }
    return Validation;
}());
export { Validation };
